import React from 'react';

import { Avatar } from '@buildoutinc/blueprint-react/ui/Avatar';

import { getInitials } from 'helpers/string_helpers';

export interface Recipient {
  name?: string;
  email: string;
  locked?: boolean;
}

interface Props {
  recipient: Recipient;
}

export default function EmailRecipient({ recipient }: Props) {
  const { name, email } = recipient;

  return (
    <span className="d-inline-flex align-items-center gap-2 text-truncate">
      <Avatar size="sm">
        <Avatar.Fallback>{getInitials(name || email)}</Avatar.Fallback>
      </Avatar>
      {name && <span className="fw-medium text-truncate">{name}</span>}
      <span className="text-muted text-truncate">{email}</span>
    </span>
  );
}
